// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPublicationCard-cls1_tWD","cls2":"EvaluationPublicationCard-cls2_hFO EvaluationPublicationCard-cls1_tWD"};